module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('link', {
    attrs: {
      "rel": "stylesheet",
      "href": "//fonts.googleapis.com/icon?family=Material+Icons"
    }
  }), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-fixed-top",
    style: ({
      'border-bottom-color': _vm.mainColor ? _vm.mainColor : '#ff9800',
      'background-color': _vm.backgroundColor ? _vm.backgroundColor : '#fff',
      '--text-color': _vm.textColor ? _vm.textColor : '#515151',
      '--main-color': _vm.mainColor ? _vm.mainColor : '#ff9800',
      '--text-hover-color': _vm.textHoverColor ? _vm.textHoverColor : '#515151',
      '--separator-color': _vm.separatorColor ? _vm.separatorColor : '#515151',
    })
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [(_vm.navLogo) ? _c('img', {
    class: ['navbar-brand-image', 'navbar-brand', _vm.showItems ? 'showed-items' : ''],
    attrs: {
      "src": _vm.navLogo
    }
  }) : (!_vm.usePinkLogo) ? _c('img', {
    class: ['navbar-brand-image', 'navbar-brand', _vm.showItems ? 'showed-items' : ''],
    attrs: {
      "src": require("../logo-white2.png")
    }
  }) : _c('img', {
    class: ['navbar-brand-image-pink', 'navbar-brand', _vm.showItems ? 'showed-items' : ''],
    attrs: {
      "src": require("../logo-dark2.png")
    }
  })]), _vm._v(" "), (_vm.title) ? _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), (_vm.showItems) ? _c('div', {
    attrs: {
      "id": "navbarResponsive"
    }
  }, [_c('nav', {
    staticClass: "navbar-nav nav"
  }, [_vm._l((_vm.navbarItems), function(item, key) {
    return _c('a', {
      key: key,
      class: ['nav-item', 'nav-link', item.active ? 'active' : ''],
      attrs: {
        "href": "#"
      }
    }, [(item.active) ? _c('a', {
      style: ({
        'border-bottom': _vm.mainColor ? '3px solid ' + _vm.mainColor : '3px solid #ff9800',
        'color': _vm.textHoverColor ? 'var(--text-hover-color)' : '#ff9800'
      }),
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.itemOnclick(item)
        }
      }
    }, [_vm._v("\n              " + _vm._s(item.name) + "\n          ")]) : _c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.itemOnclick(item)
        }
      }
    }, [_vm._v("\n              " + _vm._s(item.name) + "\n          ")])])
  }), _vm._v(" "), (_vm.showItems) ? _c('div', {
    staticClass: "navbar-burger"
  }, [_c('md-menu', {
    attrs: {
      "md-align-trigger": "",
      "md-size": "5"
    }
  }, [_c('div', {
    attrs: {
      "md-menu-trigger": ""
    }
  }, [_vm._v("\n              menu\n            ")]), _vm._v(" "), _c('md-menu-content', {
    staticClass: "menu-bar"
  }, _vm._l((_vm.navbarItems), function(item, key) {
    return _c('md-menu-item', {
      key: key,
      nativeOn: {
        "click": function($event) {
          return _vm.itemOnclick(item)
        }
      }
    }, [_c('span', {
      staticClass: "item-txt"
    }, [_vm._v(_vm._s(item.name))])])
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), _vm._t("afterNav"), _vm._v(" "), (_vm.userName) ? _c('div', {
    staticClass: "user-name"
  }, [_c('p', [_vm._v(_vm._s(_vm.userName))])]) : _vm._e(), _vm._v(" "), (_vm.showItems) ? _c('div', {
    staticClass: "navbar-user"
  }, [_c('md-menu', {
    attrs: {
      "md-align-trigger": "",
      "md-direction": _vm.userMenuDirection
    }
  }, [_c('md-button', {
    staticClass: "md-mini navbar-user-button float-xs-right",
    attrs: {
      "md-menu-trigger": ""
    }
  }, [_c('md-icon', [_vm._v("person")])], 1), _vm._v(" "), _c('md-menu-content', {
    staticClass: "menu-bar"
  }, _vm._l((_vm.profileMenuItems), function(item, key) {
    return _c('md-menu-item', {
      key: key,
      nativeOn: {
        "click": function($event) {
          return _vm.profileMenuItemOnClick(item)
        }
      }
    }, [_c('md-icon', [_vm._v(_vm._s(item.icon))]), _vm._v(" "), _c('span', {
      staticClass: "item-txt"
    }, [_vm._v(_vm._s(item.name))])], 1)
  }), 1)], 1)], 1) : _vm._e()], 2)]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-26e84591!./~/vue-loader/lib/selector.js?type=template&index=0!./~/wb-nav/wbNav/wbNav.vue
// module id = 302
// module chunks = 2